import { useQuery } from '@apollo/client';
import { GET_CURRENT_USER_TRANSACTIONS } from '../api';
import {
  CurrentUserTransactionsVariables,
  GetCurrentUserTransactionsQuery,
} from '../api/types';

interface UseUserTransactionsOptions {
  variables: CurrentUserTransactionsVariables;
  skip?: boolean;
}

export const useUserTransactions = ({
  variables,
  skip = false,
}: UseUserTransactionsOptions) => {
  const { data, loading, fetchMore, refetch } =
    useQuery<GetCurrentUserTransactionsQuery>(GET_CURRENT_USER_TRANSACTIONS, {
      skip,
      variables: {
        first: variables.first,
        after: variables.after ?? null,
      },
    });

  return {
    loading,
    refetch,
    fetchMore,
    transactions: data?.currentUserTransactions?.nodes ?? [],
    totalCount: data?.currentUserTransactions?.totalCount ?? 0,
    endCursor: data?.currentUserTransactions?.pageInfo?.endCursor,
    hasNextPage: data?.currentUserTransactions?.pageInfo?.hasNextPage ?? false,
  };
};
